"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const QwilrPayCircle = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 80 80", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("circle", { cx: 40, cy: 40, r: 39.5, fill: "#605CAB", stroke: "#E0E8F1" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        opacity: 0.7,
        d: "M24.5838 49.5555L23.0938 47.7079C21.9912 48.2741 20.7097 48.5721 19.3687 48.5721C14.2728 48.5721 10.7266 44.5789 10.7266 39.1254C10.7266 33.6421 14.2728 29.6786 19.3687 29.6786C24.4646 29.6786 28.0407 33.6421 28.0407 39.1254C28.0407 41.8372 27.1169 44.1616 25.5672 45.8603L27.0275 47.6483L24.5838 49.5555ZM24.1964 39.1254C24.1964 35.5493 22.2892 33.0758 19.3687 33.0758C16.4781 33.0758 14.6006 35.5493 14.6006 39.1254C14.6006 42.7014 16.4781 45.2643 19.3687 45.2643C19.9349 45.2643 20.4713 45.2047 20.9481 45.0557L19.4581 43.1782L21.9018 41.3008L23.3322 43.0888C23.8984 42.1054 24.1964 40.7942 24.1964 39.1254Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M61.9898 53.1961H58.3542L60.2912 48.3386L55.1953 34.9581H59.0992L62.1686 43.8089L65.2083 34.9581H68.9334L61.9898 53.1961Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M54.8117 48.2785H51.2655V47.5633C50.8184 48.0103 49.4774 48.5169 48.0172 48.5169C45.3352 48.5169 43.0703 46.9673 43.0703 44.1958C43.0703 41.6628 45.3352 39.9343 48.2258 39.9343C49.388 39.9343 50.729 40.3218 51.2655 40.7092V39.7257C51.2655 38.5933 50.58 37.6695 49.09 37.6695C48.047 37.6695 47.4212 38.1463 47.1232 38.9211H43.6067C43.9941 36.5073 46.1696 34.6597 49.2092 34.6597C52.7555 34.6597 54.8117 36.5967 54.8117 39.7853V48.2785ZM51.2655 44.6428V43.6892C50.9377 42.974 49.9244 42.527 48.8516 42.527C47.6894 42.527 46.4974 43.0336 46.4974 44.166C46.4974 45.3282 47.6894 45.8051 48.8516 45.8051C49.9244 45.8051 50.9377 45.358 51.2655 44.6428Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M36.5986 41.9276H32.9331V48.2751H29.1484V29.9776H36.5986C40.4726 29.9776 43.0355 32.0636 43.0355 35.9675C43.0355 39.8416 40.4726 41.9276 36.5986 41.9276ZM39.2806 35.9675C39.2806 34.3285 38.327 33.2259 36.3602 33.2259H32.9331V38.6794H36.3602C38.327 38.6794 39.2806 37.5469 39.2806 35.9675Z",
        fill: "white"
      }
    )
  );
};
export default QwilrPayCircle;
